<template>
  <div class="footer">
    <div class="logo">萨岗陀骆</div>
    <div class="contact">加盟热线：18189919488</div>
    <div class="footer-content">Copyright © 2022-2025 <a href="https://beian.miit.gov.cn" target="_blank">藏ICP备2024002292号-2</a></div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 150px;
    background: #0056A3;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #ffffff;
    gap: 15px;
    .logo {
      font-size: 36px;
      font-weight: bold;
    }
  }
  .footer-content {
    a {
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
      font-weight: bold;
    }
  }
</style>